<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div v-else class="w-full">
      <div
        slot="no-body"
        class="tabs-container inventory_tabSec"
        id="view-customer-tab"
      >
        <vs-tabs
          alignment="fixed"
          v-model="activeTab"
          class="tab-action-btn-fill-conatiner"
        >
          <vs-tab :label="$t('setup.label.MediaDetails')">
            <vx-card>
              <vs-table
                :max-items="paginationItems[1]"
                pagination
                :data="hardwareMediaList"
                :description="false"
                @selected="handleSelected"
                search
                :description-items="paginationItems"
                description-title="Registries"
                description-connector="of"
                description-body="Pages"
              >
                <template slot="header">
                  <div class="list-heading">
                    {{ $t("setup.label.DetailsOfMedia") }}
                  </div>
                  <div class="mr-2 mb-1 order-1">
                    <vs-button
                      icon-pack="feather"
                      icon="icon-plus"
                      @click="$router.push({ name: 'Create Media' })"
                      size="small"
                      >{{ $t("setup.label.Media") }}</vs-button
                    >
                  </div>
                  <div class="mr-2 mb-1 order-1">
                    <vs-button
                      icon-pack="feather"
                      icon="icon-plus"
                      @click="$router.push({ name: 'Add Media' })"
                      size="small"
                      >{{ $t("setup.label.AdvMedia") }}</vs-button
                    >
                  </div>
                </template>
                <template slot="thead">
                  <vs-th>{{ $t("setup.label.MediaTitle") }}</vs-th>
                  <vs-th>{{ $t("setup.label.MediaCatagory") }}</vs-th>
                  <vs-th>{{ $t("setup.label.ContentProvider") }}</vs-th>
                  <vs-th>{{ $t("setup.label.Share") }}</vs-th>
                  <vs-th>{{ $t("setup.label.Status") }}</vs-th>
                  <vs-th class="tHeadCenter">{{
                    $t("setup.label.Action")
                  }}</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :key="index"
                    :data="hardwareMediaList"
                    v-for="(hardwareMediaList, index) in data"
                  >
                    <vs-td :data="hardwareMediaList.mediaTitle">{{
                      hardwareMediaList.mediaTitle
                    }}</vs-td>
                    <vs-td :data="hardwareMediaList.mediaCategory">{{
                      hardwareMediaList.mediaCategory
                    }}</vs-td>

                    <vs-td :data="hardwareMediaList.contentProviderValue">{{
                      hardwareMediaList.contentProviderValue
                    }}</vs-td>
                    <vs-td :data="hardwareMediaList.cpShareValue">{{
                      hardwareMediaList.cpShareValue
                    }}</vs-td>

                    <vs-td :data="hardwareMediaList.status">{{
                      hardwareMediaList.status
                    }}</vs-td>
                    <vs-td class="whitespace-no-wrap">
                      <div class="container_img">
                        <feather-icon
                          icon="EditIcon"
                          :title="$t('setup.label.EditMedia')"
                          svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                          @click.stop="
                            editCreateDevice(hardwareMediaList.mediaId)
                          "
                          class="icon_row"
                        />
                        <feather-icon
                          icon="PlusIcon"
                          :title="$t('setup.label.AddEvent')"
                          class="icon_row"
                          svgClasses="w-5 h-5 text-warning hover:text-primary stroke-current cursor"
                          @click.stop="$router.push({ name: 'Create Event' })"
                        />

                        <feather-icon
                          icon="BookIcon"
                          :title="$t('setup.label.AddAttributes')"
                          svgClasses="w-5 h-5 text-warning hover:text-primary stroke-current cursor"
                          @click.stop="
                            editJobsUomPopup = true;
                            attId = hardwareMediaList.mediaId;
                            handleAddAttributes(hardwareMediaList.mediaId);
                          "
                          class="icon_row"
                        />
                        <feather-icon
                          icon="MapPinIcon"
                          :title="$t('setup.label.AddLocation')"
                          class="icon_row"
                          svgClasses="w-5 h-5 text-warning hover:text-primary stroke-current cursor"
                          @click.stop="
                            mediaLocationPopup = true;
                            locId = hardwareMediaList.mediaId;
                            handleAddLocations(hardwareMediaList.mediaId);
                          "
                        />
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <div class="centerx">
                <vs-popup
                  classContent="popup-example"
                  :title="$t('setup.label.MediaAttributes')"
                  :active.sync="editJobsUomPopup"
                  class="popup-close"
                >
                  <div class="vx-row mt-4">
                    <div class="vx-col w-1/4">
                      <vs-input
                        :label="$t('setup.label.Cast')"
                        class="w-full mb-2 font-semibold starlabel"
                        v-model="attributes.attributeType"
                      />
                    </div>

                    <div class="vx-col w-1/4">
                      <div class="dropdown-with-label">
                        <small class="date-label font-semibold">{{
                          $t("setup.label.AttributeType")
                        }}</small>
                        <v-select
                          label="mediaName"
                          v-model="attributes.attributeName"
                          :options="mediaAttributes"
                          :reduce="(data) => data.id"
                          :placeholder="$t('placeholder.label.SelectOne')"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          class="w-full mb-2"
                        >
                        </v-select>
                      </div>
                    </div>
                    <div class="vx-col w-1/4">
                      <vs-input
                        :label="$t('setup.label.CaptionValue')"
                        class="w-full mb-2 font-semibold starlabel"
                        v-model="attributes.attributeValue"
                      />
                    </div>
                    <div class="vx-col w-1/4">
                      <vs-input
                        :label="$t('setup.label.NickName')"
                        class="w-full mb-2 font-semibold starlabel"
                        v-model="attributes.attributeNickname"
                      />
                    </div>
                    <div class="vx-col w-1/4">
                      <vs-input
                        :label="$t('setup.label.Image')"
                        class="w-full mb-2 font-semibold starlabel"
                        v-model="attributes.attributeImage"
                      />
                    </div>
                    <div class="vx-col md:w-1/8 mt-4" style="margin: 0.5rem 0">
                      <vs-button
                        @click="addParameter"
                        icon-pack="feather"
                        icon="icon-plus"
                        title="add"
                        color="success"
                        svgClasses="w-5 h-5 hover:text-primary stroke-current cursor"
                      >
                      </vs-button>
                    </div>
                  </div>
                  <div class="vx-row mt-6">
                    <div
                      class="vx-col w-100 lg:w-100 md:w-100 sm:w-100 xs:w-100"
                    >
                      <div class="block">
                        <vs-table
                          style="width: 660px"
                          class="ml-3 mr-2 vx-row w-100"
                          :description-items="paginationItems"
                          description-title="Registries"
                          description-connector="of"
                          description-body="Pages"
                          :data="attributes.attribureDetailDatas"
                        >
                          <template slot="thead">
                            <vs-th>{{ $t("setup.label.Cast") }}</vs-th>
                            <vs-th>{{ $t("setup.label.AttributeType") }}</vs-th>
                            <vs-th>{{ $t("setup.label.CaptionValue") }}</vs-th>
                            <vs-th>{{ $t("setup.label.NickName") }}</vs-th>
                            <vs-th>{{ $t("setup.label.Image") }}</vs-th>
                            <vs-th>{{ $t("setup.label.Action") }}</vs-th>
                          </template>
                          <template slot-scope="{ data }">
                            <vs-tr
                              :key="index"
                              :data="attributes"
                              v-for="(attributes, index) in data"
                            >
                              <vs-td :data="attributes.attributeType">{{
                                attributes.attributeType
                              }}</vs-td>
                              <vs-td :data="attributes.attributeName">{{
                                attributes.attributeName
                              }}</vs-td>
                              <vs-td v-if="attributes.attributeValue">
                                {{ attributes.attributeValue }}
                              </vs-td>
                              <vs-td v-else>
                                {{ attributes.attributevalue }}
                              </vs-td>
                              <vs-td :data="attributes.attributeNickname">
                                {{ attributes.attributeNickname }}
                              </vs-td>
                              <vs-td :data="attributes.attributeImage">
                                {{ attributes.attributeImage }}
                              </vs-td>
                              <vs-td class="whitespace-no-wrap">
                                <div class="container_img">
                                  <button
                                    @click="removeItem(index)"
                                    class="bGNone border-none view_editTable_btn"
                                  >
                                    <feather-icon
                                      icon="TrashIcon"
                                      :title="$t('setup.label.Delete')"
                                      svgClasses="w-5 h-5 text-danger stroke-current cursor"
                                      class="icon_row"
                                    />
                                  </button>
                                </div>
                              </vs-td>
                            </vs-tr>
                          </template>
                        </vs-table>
                      </div>
                    </div>
                  </div>
                  <div class="vx-row">
                    <span class="ml-4 mr-1">
                      <vs-button
                        style="margin-left: 230px; margin-top: 50px"
                        type="border"
                        @click="editJobsUomPopup = false"
                        >{{ $t("setup.label.Cancel") }}</vs-button
                      >
                    </span>
                    <span class="ml-1 mr-2">
                      <vs-button
                        style="margin-top: 50px"
                        @click="createatt(attId)"
                        color="primary"
                        >{{ $t("setup.label.Save") }}</vs-button
                      >
                    </span>
                  </div>
                </vs-popup>
              </div>
              <div class="centerx">
                <vs-popup
                  classContent="popup-example"
                  :title="$t('setup.label.AddMediaLocations')"
                  :active.sync="mediaLocationPopup"
                  class="popup-close"
                >
                  <div class="vx-row mt-4">
                    <div class="vx-col w-1/4">
                      <div class="dropdown-with-label">
                        <small class="date-label font-semibold">{{
                          $t("setup.label.LanguageData")
                        }}</small>
                        <v-select
                          label="mCodeValue"
                          v-model="locations.mediaLanguage"
                          :reduce="(data) => data.id"
                          :options="mediaLanguageData"
                          :placeholder="$t('placeholder.label.SelectOne')"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          class="w-full mb-2"
                        >
                        </v-select>
                      </div>
                    </div>
                    <div class="vx-col w-1/4">
                      <div class="dropdown-with-label">
                        <small class="date-label font-semibold">{{
                          $t("setup.label.FormatData")
                        }}</small>
                        <v-select
                          label="mediaName"
                          v-model="locations.mediaFormat"
                          :reduce="(data) => data.mediaName"
                          :options="mediaFormat"
                          :placeholder="$t('placeholder.label.SelectOne')"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          class="w-full mb-2"
                        >
                        </v-select>
                      </div>
                    </div>

                    <div class="vx-col w-1/4">
                      <vs-input
                        :label="$t('setup.label.MediaLocation')"
                        class="w-full mb-2 font-semibold starlabel"
                        v-model="locations.mediaLocation"
                      />
                    </div>
                    <div class="vx-col md:w-1/8 mt-4" style="margin: 0.5rem 0">
                      <vs-button
                        @click="addLocation"
                        icon-pack="feather"
                        icon="icon-plus"
                        title="add"
                        color="success"
                        svgClasses="w-5 h-5 hover:text-primary stroke-current cursor"
                      >
                      </vs-button>
                    </div>
                  </div>
                  <div class="vx-row mt-6">
                    <div
                      class="vx-col w-100 lg:w-100 md:w-100 sm:w-100 xs:w-100"
                    >
                      <div class="block">
                        <vs-table
                          style="width: 660px"
                          class="ml-3 mr-2 vx-row w-100"
                          :description-items="paginationItems"
                          description-title="Registries"
                          description-connector="of"
                          description-body="Pages"
                          :data="locations"
                        >
                          <template slot="thead">
                            <vs-th>{{ $t("setup.label.LanguageData") }}</vs-th>
                            <vs-th>{{ $t("setup.label.FormatData") }}</vs-th>
                            <vs-th>{{ $t("setup.label.MediaLocation") }}</vs-th>
                            <vs-th>{{ $t("setup.label.Action") }}</vs-th>
                          </template>
                          <template slot-scope="{ data }">
                            <vs-tr
                              :key="index"
                              :data="locations"
                              v-for="(
                                locations, index
                              ) in locations.locationsDetailDatas"
                            >
                              <vs-td :data="locations.languageId">{{
                                locations.languageId
                              }}</vs-td>
                              <vs-td :data="locations.formatType">{{
                                locations.formatType
                              }}</vs-td>
                              <vs-td :data="locations.location">
                                {{ locations.location }}
                              </vs-td>
                              <vs-td class="whitespace-no-wrap">
                                <div class="container_img">
                                  <button
                                    @click="removeItemLocation(index)"
                                    class="bGNone border-none view_editTable_btn"
                                  >
                                    <feather-icon
                                      icon="TrashIcon"
                                      :title="$t('setup.label.Delete')"
                                      svgClasses="w-5 h-5 text-danger stroke-current cursor"
                                      class="icon_row"
                                    />
                                  </button>
                                </div>
                              </vs-td>
                            </vs-tr>
                          </template>
                        </vs-table>
                      </div>
                    </div>
                  </div>
                  <div class="vx-row">
                    <span class="ml-4 mr-1">
                      <vs-button
                        style="margin-left: 230px; margin-top: 50px"
                        type="border"
                        @click="mediaLocationPopup = false"
                        >{{ $t("setup.label.Cancel") }}</vs-button
                      >
                    </span>
                    <span class="ml-1 mr-2">
                      <vs-button
                        style="margin-top: 50px"
                        @click="createlocatt(locId)"
                        color="primary"
                        >{{ $t("setup.label.Save") }}</vs-button
                      >
                    </span>
                  </div>
                </vs-popup>
              </div>
            </vx-card>
          </vs-tab>
          <vs-tab :label="$t('setup.label.Event')">
            <vx-card>
              <vs-table
                :max-items="paginationItems[1]"
                pagination
                :data="provisioningEventList"
                :description="false"
                @selected="handleSelected2"
                search
                :description-items="paginationItems"
                description-title="Registries"
                description-connector="of"
                description-body="Pages"
              >
                <template slot="header">
                  <div class="list-heading">
                    {{ $t("setup.label.DetailsOfEvent") }}
                  </div>
                  <div class="mr-2 mb-1 order-1">
                    <vs-button
                      icon-pack="feather"
                      icon="icon-plus"
                      @click="$router.push({ name: 'Create Event' })"
                      size="small"
                      >{{ $t("setup.label.CreateEvent") }}</vs-button
                    >
                  </div>
                </template>
                <template slot="thead">
                  <vs-th>{{ $t("setup.label.EventName") }}</vs-th>
                  <vs-th>{{ $t("setup.label.EventDescription") }}</vs-th>
                  <vs-th>{{ $t("setup.label.EventCategory") }}</vs-th>
                  <vs-th>{{ $t("setup.label.Status") }}</vs-th>
                  <vs-th class="tHeadCenter">{{
                    $t("setup.label.Action")
                  }}</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :key="index"
                    :data="provisioningEventList"
                    v-for="(provisioningEventList, index) in data"
                  >
                    <vs-td :data="provisioningEventList.eventName">{{
                      provisioningEventList.eventName
                    }}</vs-td>
                    <vs-td :data="provisioningEventList.eventDescription">{{
                      provisioningEventList.eventDescription
                    }}</vs-td>
                    <vs-td :data="provisioningEventList.eventCategory">{{
                      provisioningEventList.eventCategory
                    }}</vs-td>
                    <vs-td :data="provisioningEventList.status">{{
                      provisioningEventList.status
                    }}</vs-td>

                    <vs-td class="whitespace-no-wrap">
                      <div class="container_img">
                        <feather-icon
                          icon="EditIcon"
                          :title="$t('setup.label.Edit')"
                          svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                          @click.stop="
                            editEventHandle(provisioningEventList.id)
                          "
                          class="icon_row"
                        />
                        <feather-icon
                          icon="TrashIcon"
                          :title="$t('setup.label.Delete')"
                          svgClasses="w-5 h-5 text-danger stroke-current cursor"
                          @click.stop="
                            editJobsRumPopup = true;
                            delId = provisioningEventList.id;
                          "
                          class="icon_row"
                        />
                        <feather-icon
                          icon="PlusIcon"
                          :title="$t('setup.label.AddPrice')"
                          svgClasses="w-5 h-5 text-danger stroke-current cursor"
                          @click.stop="addEventPrice(provisioningEventList.id)"
                          class="icon_row"
                        />
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <div class="centerx">
                <vs-popup
                  classContent="popup-example"
                  :title="$t('setup.label.DeleteEvent')"
                  :active.sync="editJobsRumPopup"
                  class="popup-close mid-popup"
                >
                  <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
                    <div class="vx-col sm:w-full w-full">
                      <div class="vx-col sm:w-full w-full">{{$t("setup.label.Are_you_sure_?")}}</div>
                    </div>
                  </div>
                  <div class="vx-row">
                    <span class="ml-4 mr-1">
                      <vs-button
                        type="border"
                        @click="editJobsRumPopup = false"
                        >{{ $t("setup.label.Cancel") }}</vs-button
                      >
                    </span>
                    <span class="ml-1 mr-2">
                      <vs-button
                        @click="handleDeleteEvent(delId)"
                        color="warning"
                        >{{ $t("setup.label.Ok") }}</vs-button
                      >
                    </span>
                  </div>
                </vs-popup>
              </div>
            </vx-card>
          </vs-tab>
        </vs-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import vSelect from "vue-select";
import { AtomSpinner } from "epic-spinners";

const teamEmptyObj = {
  mediaName: "",
  attributeType: "",
  attributeName: "",
  attributeValue: "",
  attributeNickname: "",
  attribureDetailDatas: [],
  attributeImage: "",
};
const locationEmptyObj = {
  mediaName: "",
  mediaLanguage: "",
  mediaLocation: "",
  locationsDetailDatas: [],
  mediaFormat: "",
};
export default {
  data() {
    return {
      activeTab: 0,
      loading: false,
      paginationItems: [5, 10, 15],
      deletePopup: false,
      delId: 0,
      deleatId: 0,
      mediaAttributes: [],
      mediaLanguageData: [],
      mediaFormat: [],
      attributes: teamEmptyObj,
      locations: locationEmptyObj,
      mediaLocationPopup: false,
      editJobsUomPopup: false,
      editJobsRumPopup: false,
      provisioningActionsList: [],
      networkElementList: [],
      attributeMediaList: {},
    };
  },
  components: {
    "v-select": vSelect,
    AtomSpinner,
  },

  computed: {
    ...mapState({
      hardwareMediaList: (state) => state.mediaDetails.Medialist,
      provisioningEventList: (state) => state.mediaDetails.Eventlist,
      template: (state) => state.mediaDetails.AddAttributeTemplateList,
    }),
  },
  methods: {
    async getUomData() {
      try {
        this.$store.dispatch("mediaDetails/setMediaList", {});
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getEventListData() {
      try {
        await this.$store.dispatch("mediaDetails/setEventList");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    editCreateDevice(id) {
      this.$router.push({ name: "Edit Media", params: { id: id } });
    },
    editCreatesystem(id) {
      this.$router.push({ name: "Edit Create System", params: { id: id } });
    },
    editEventHandle(id) {
      this.$router.push({ name: "Edit Event", params: { id: id } });
    },
    handleSelected2(provisioningEventList) {
      this.$router.push({
        name: "View Event",
        params: { id: provisioningEventList.id },
      });
    },
    handleSelected(hardwareMediaList) {
      this.$router.push({
        name: "View Media",
        params: { id: hardwareMediaList.mediaId },
      });
    },
    async handleDeleteEvent(id) {
      try {
        await this.$store.dispatch("mediaDetails/deleteEventAction", id);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async handleAddAttributes() {
      // await this.getDataById(id);
      this.attributes.attribureDetailDatas = [];
      this.getDiscountTemplate();
    },
    async handleAddLocations() {
      this.locations.locationsDetailDatas = [];
      this.getLocationDevice();
    },
    async getDiscountTemplate() {
      try {
        await this.$store.dispatch("mediaDetails/setAddAttributesTemplate");
        this.mediaAttributes = [
          { id: 0, mediaName: "" },
          ...this.template.mediaAttributes,
        ];
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    removeItem(i) {
      this.attributes.attribureDetailDatas.splice(i, 1);
    },
    addParameter() {
      try {
        let createParameter = {
          attributeType: this.attributes.attributeType,
          attributeName: this.attributes.attributeName,
          attributevalue: this.attributes.attributeValue,
          attributeNickname: this.attributes.attributeNickname,
          attributeImage: this.attributes.attributeImage,
        };
        this.attributes.attribureDetailDatas = [
          ...this.attributes.attribureDetailDatas,
          createParameter,
        ];
        this.attributes.attributeType = "";
        this.attributes.attributeName = "";
        this.attributes.attributeValue = "";
        this.attributes.attributeNickname = "";
        this.attributes.attributeImage = "";
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createatt(id) {
      const payload = {
        id: id,
        data: {
          mediaDetailType: "ATTRIBUTES",
          mediaassetAttributes: this.attributes.attribureDetailDatas,
        },
      };
      try {
        await this.$store.dispatch(
          "mediaDetails/createattributeAction",
          payload
        );
        this.editJobsUomPopup = false;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async createlocatt(id) {
      const payload = {
        id: id,
        data: {
          mediaDetailType: "LOCATIONS",
          mediaAssetLocations: this.locations.locationsDetailDatas,
        },
      };
      try {
        await this.$store.dispatch(
          "mediaDetails/createattributeAction",
          payload
        );
        this.mediaLocationPopup = false;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    addEventPrice(eventId) {
      const id = eventId;
      this.$router.push({ name: "Add Price", params: { id: id } });
    },
    async getLocationDevice() {
      try {
        await this.$store.dispatch("mediaDetails/setAddAttributesTemplate");

        this.mediaLanguageData = [
          { id: 0, mCodeValue: "" },
          ...this.template.mediaLanguageData,
        ];
        this.mediaFormat = [
          { id: 0, mediaName: "" },
          ...this.template.mediaFormat,
        ];
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    removeItemLocation(i) {
      this.locations.locationsDetailDatas.splice(i, 1);
    },
    addLocation() {
      try {
        let crateLocParameter = {
          formatType: this.locations.mediaFormat,
          languageId: this.locations.mediaLanguage,
          location: this.locations.mediaLocation,
        };
        this.locations.locationsDetailDatas = [
          ...this.locations.locationsDetailDatas,
          crateLocParameter,
        ];
        this.locations.mediaFormat = "";
        this.locations.mediaLanguage = "";
        this.locations.mediaLocation = "";
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  async mounted() {
    this.loading = true;
    this.getUomData();
    this.getEventListData();
    this.loading = false;
  },
};
</script>
<style scoped>
::v-deep .vs-tabs--ul {
  width: 50%;
}
.inventory_tabSec >>> .con-vs-tabs .vs-tabs--ul {
  box-shadow: none !important;
}
.under_input {
  width: 140px;
}
</style>
